import { createSlice } from '@reduxjs/toolkit';

import { IJobState } from 'src/features/job/domain/types';

import { getJob, getJobs, JOB_LOADING_KEY } from './jobThunks';

const initialState: IJobState = {
	paginatedJobList: null,
};

const jobsSlice = createSlice({
	name: JOB_LOADING_KEY,
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getJobs.fulfilled, (state, action) => {
			state.paginatedJobList = action.payload;
		});

		builder.addCase(getJob.fulfilled, (state, action) => {
			if (state.paginatedJobList?.results) {
				const index = state.paginatedJobList.results.findIndex(
					(job) => job.id === action.payload.id,
				);

				if (index !== -1) {
					state.paginatedJobList.results[index] = action.payload;
				}
			}
		});
	},
});

export default jobsSlice.reducer;
